import { PodcastDetailPage } from "./PodcastDetailPage";

export default PodcastDetailPage;
